import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../utils';
import { partnerApiPath } from '../apiPath';
import { partnerHttpClient } from '../httpClient';

const GetPartnerBrandsRequestSchema = z
  .object({
    platform: z.string().optional(),
  })
  .describe('GetPartnerBrandsRequestSchema');

export type GetPartnerBrandsRequest = z.infer<typeof GetPartnerBrandsRequestSchema>;

const PartnerBrandSchema = z
  .object({
    brandId: z.string(),
    brandName: z.string(),
    platform: z.string(),
  })
  .describe('PartnerBrandSchema');

export type PartnerBrand = z.infer<typeof PartnerBrandSchema>;

const GetPartnerBrandsResponseDataSchema = z
  .object({
    brands: z.array(PartnerBrandSchema),
  })
  .describe('GetPartnerBrandsResponseDataSchema');

const GetPartnerBrandsResponseSchema = createApiResponseSchema(GetPartnerBrandsResponseDataSchema);

export type GetPartnerBrandsResponse = z.infer<typeof GetPartnerBrandsResponseSchema>;

/** GET `/v1/partner/brands` — 파트너 보유 브랜드 목록 */
export const getPartnerBrands = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetPartnerBrandsRequestSchema),
    async (params: GetPartnerBrandsRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetPartnerBrandsResponse>(partnerApiPath.getBrands, params),
      ),
    validateApiResponse(GetPartnerBrandsResponseSchema),
  ),
);
